export const tr = {
  "nav.check_booking": "Rezervasyonu Kontrol Et",
  "nav.admin": "Yönetici",
  "nav.book_now": "Hemen Rezervasyon Yap",
  "nav.driver": "Sürücü",
  "hero.badge": "J1 Vize Öğrenci Ulaşımı",
  "hero.title": "Easy Transportation",
  "hero.subtitle": "Chicago Havalimanlarından Wisconsin'e Güvenilir Ulaşımınız",
  "hero.description": "J1 vize öğrencileri için güvenli, güvenilir ve uygun fiyatlı ulaşım. Bugün havalimanı servisinizi rezerve edin!",
  "hero.book_trip": "Yolculuğunuzu Rezerve Edin",
  "hero.check_status": "Rezervasyon Durumunu Kontrol Et",
  "pricing.title": "Ulaşım Fiyatları",
  "pricing.subtitle": "Tüm fiyatlar USD cinsindendir",
  "pricing.ohare_mke": "Transfer (O'Hare / Milwaukee)",
  "pricing.midway": "Transfer (Midway)",
  "pricing.madison": "Madison'dan Wisconsin Dells'e",
  "pricing.return": "Dönüş İndirimi",
  "pricing.shared": "Paylaşımlı Yolculuk",
  "pricing.private": "Özel Yolculuk",
  "pricing.per_person": "kişi başı",
  "pricing.after_deposit": "$20 depozito ile",
  "pricing.without_deposit": "depozitosuz",
  "pricing.flat_rate": "sabit fiyat",
  "pricing.per_suitcase": "Bavul başına",
  "pricing.carry_on": "El bagajı",
  "pricing.free": "ÜCRETSİZ",
  "pricing.with_shipping": "Dönüş + bizimle gönderi",
  "pricing.special_deal": "Özel Teklif!",
  "pricing.midway_contact": "Midway (MDW) fiyatları için bize ulaşın",
  "pricing.waterpark_note": "Three Bears Water Park veya diğer destinasyonlar için fiyatlar farklılık gösterebilir.",
  "pricing.contact_us": "Bize ulaşın",
  "pricing.guidelines_title": "Fiyatlandırmamız Nasıl Çalışır",
  "pricing.guidelines_deposit": "Kişi başı $20 depozito rezervasyonunuzu güvence altına alır. Kalan bakiye yolculuk gününde ödenir.",
  "pricing.guidelines_shared": "Aynı gün aynı havalimanına giden 2 veya daha fazla yolcu paylaşımlı yolculuk fiyatı alır.",
  "pricing.guidelines_solo": "Tek başına yolculuk eden yolcular (o gün tek yolcu) biraz daha yüksek ücret ödeyebilir.",
  "pricing.guidelines_suitcase": "Dönüş yolculuklarında 1 bavul ücretsizdir. Her ek bavul $5'tir.",
  "pricing.guidelines_payment": "Kart, Nakit ve Zelle ödemelerini kabul ediyoruz.",
  "requirements.title": "Rezervasyon Gereksinimleri",
  "requirements.pickup": "Aksi bildirilmedikçe 24 saat içinde iki kez servis sunuyoruz. Önceden planlayın ve rezervasyon yapın!",
  "requirements.deposit": "Programa eklenmeniz için iade edilemez $3.200 JMD (veya $20 USD) depozito gereklidir.",
  "requirements.seamless": "Gecikmeleri önlemek için depozitonuzu önceden yaparak yerinizi güvence altına alın.",
  "requirements.final_payment": "Kalan bakiye araca binmeden önce ödenmelidir.",
  "special.title": "Hedefiniz Listede Yok mu?",
  "special.description": "Düzenli rotalarımız dışındaki destinasyonlara özel yolculuklar sunuyoruz. Teklif için bize ulaşın!",
  "special.call": "Ara",
  "special.whatsapp": "WhatsApp",
  "features.title": "Neden Easy Transportation?",
  "features.subtitle": "Her yaz binlerce J1 öğrencisi tarafından güvenilmektedir",
  "features.easy_booking": "Kolay Rezervasyon",
  "features.easy_booking_desc": "Sadece $3.200 JMD ($20 USD) depozito gerekli. Banka transferi, kart, PayPal veya Zelle ile ödeyin.",
  "features.safe": "Güvenli ve Güvenilir",
  "features.safe_desc": "Profesyonel sürücüler, konforlu araçlar ve J1 öğrencileri için 7/24 destek.",
  "features.flexible": "Esnek Program",
  "features.flexible_desc": "Varış ve dönüş yolculukları rezerve edin. Dönüşlerde ilk bavul ücretsiz!",
  "video.badge": "Bizi İzleyin",
  "video.title": "Yolculuğunuz Burada Başlıyor",
  "video.subtitle": "Jamaika ve Dominik Cumhuriyeti'nden J1 öğrencilerinin maceralarını izleyin",
  "video.book_now": "Hemen Rezervasyon Yapın",
  "booking.title": "Yolculuğunuzu Rezerve Edin",
  "booking.step": "Adım",
  "booking.of": "/",
  "booking.trip_type": "Yolculuk Türü",
  "booking.arrival": "Varış (Havalimanı Servisi)",
  "booking.return": "Dönüş (Havalimanına)",
  "booking.ride_type": "Hizmet Türü",
  "booking.shared_ride": "Paylaşımlı Yolculuk",
  "booking.shared_desc": "Aynı rotadaki diğer yolcularla paylaşın",
  "booking.private_ride": "Özel Yolculuk",
  "booking.private_desc": "Sadece size özel araç",
  "booking.pickup_location": "Kalkış Havalimanı",
  "booking.select_airport": "Havalimanı Seçin",
  "booking.travel_date": "Seyahat Tarihi",
  "booking.travel_time": "Tahmini Varış Saati",
  "booking.departure_time": "Kalkış Saati",
  "booking.flight_number": "Uçuş Numarası",
  "booking.airline": "Havayolu",
  "booking.terminal": "Varış Terminali",
  "booking.full_name": "Ad Soyad",
  "booking.whatsapp": "WhatsApp Numarası",
  "booking.email": "E-posta Adresi",
  "booking.housing": "Konaklama Birimi",
  "booking.select_housing": "Konaklama Seçin",
  "booking.custom_address": "Özel Adres Girin",
  "booking.num_passengers": "Yolcu Sayısı",
  "booking.suitcases": "Toplam Bavul",
  "booking.shipping": "T&M Courier hizmetlerini mi kullanıyorsunuz?",
  "booking.payment": "Ödeme Yöntemi",
  "booking.referral": "Referans Kodu",
  "booking.next": "İleri",
  "booking.previous": "Geri",
  "booking.submit": "Rezervasyonu Tamamla",
  "booking.processing": "İşleniyor...",
  "booking.start_over": "Baştan Başla",
  "booking.first_time": "İlk Kez Seyahat",
  "booking.returning": "Tekrar Gelen Müşteri",
  "booking.confirmation_number": "Onay Numarası",
  "pricing_summary.title": "Fiyat Özeti",
  "pricing_summary.trip_price": "Yolculuk Fiyatı",
  "pricing_summary.luggage_fee": "Bagaj Ücreti",
  "pricing_summary.deposit": "Depozito",
  "pricing_summary.per_person": "kişi başı",
  "pricing_summary.discount": "Referans İndirimi",
  "pricing_summary.total_now": "Şimdi Ödenecek Toplam",
  "pricing_summary.balance": "Kalan Bakiye",
  "success.title": "Rezervasyon Onaylandı!",
  "success.confirmation": "Onay Numarası",
  "success.details": "Rezervasyon Detayları",
  "success.whatsapp_optin": "WhatsApp ile güncellemeler alın",
  "success.home": "Ana Sayfaya Dön",
  "driver.title": "Sürücü Paneli",
  "driver.login": "Sürücü Girişi",
  "driver.phone": "Telefon Numarası",
  "driver.pin": "PIN Kodu",
  "driver.sign_in": "Giriş Yap",
  "driver.trips_today": "Bugünkü Yolculuklar",
  "driver.upcoming": "Yaklaşan Yolculuklar",
  "driver.passengers": "yolcu",
  "driver.suitcases": "bavul",
  "driver.navigate": "Toplama Noktasına Git",
  "driver.contact": "Yolcuyla İletişim",
  "driver.complete": "Yolculuğu Tamamla",
  "driver.logout": "Çıkış Yap",
  "driver.no_trips": "Planlanmış yolculuk yok",
  "common.loading": "Yükleniyor...",
  "common.error": "Bir şeyler yanlış gitti",
  "common.save": "Kaydet",
  "common.cancel": "İptal",
  "common.close": "Kapat",
  "common.details": "Detaylar",
  "common.status": "Durum",
  "common.date": "Tarih",
  "common.time": "Saat",
  "common.price": "Fiyat",
  "common.passenger": "Yolcu",
  "common.passengers": "Yolcular",
};
